import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { loginCover, logo } from "../../assets/images";
import { setFavourites } from "../../Components/redux/favouritesSlice";
import { setCartItems } from "../../Components/redux/cartItemsSlice";
import { setLocations } from "../../Components/redux/locationsSlice"; // <-- yeni ekle
import { setComments } from "../../Components/redux/commentsSlice"; // <-- yeni ekle
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../Components/redux/userSlice";

export default function Login() {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user.isLoggedIn) {
      navigate("/");
    }

    if (error) {
      const timeout = setTimeout(() => {
        setError(""); // Hata mesajını temizle
      }, 3000);

      return () => clearTimeout(timeout);
    }

    if (msg) {
      const timeout = setTimeout(() => {
        setMsg(""); // Mesajı temizle
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [user.isLoggedIn, error, msg, navigate]);

  const handleInputChange = (e, type) => {
    switch (type) {
      case "email":
        setError("");
        setEmail(e.target.value);
        if (e.target.value === "") {
          setError("Email has left blank");
        }
        break;
      case "password":
        setError("");
        setPassword(e.target.value);
        if (e.target.value === "") {
          setError("Password has left blank");
        }
        break;
      default:
    }
  };

  const loginSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.get(
        "https://www.elzabeauty.az/elza/users.php"
      );
      const users = response.data.data;

      // FormData ilə alınan email və password
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      const inputEmail = formData.get("email");
      const inputPassword = formData.get("password");

      // Eyni email və şifrə ilə uyğun bütün istifadəçiləri tap
      const matchedUsers = users.filter(
        (user) => user.email === inputEmail && user.password === inputPassword
      );

      if (matchedUsers.length > 0) {
        // Doğrulanmış istifadəçi varsa
        const verifiedUser = matchedUsers.find((user) => user.is_verified == 1);

        if (verifiedUser) {
          const userId = verifiedUser.id;

          dispatch(
            setUser({
              id: userId,
              name: verifiedUser.name,
              surname: verifiedUser.surname,
              email: verifiedUser.email,
              password: verifiedUser.password,
            })
          );

          // FAVOURITES
          try {
            const favRes = await axios.get(
              `https://www.elzabeauty.az/elza/favourites.php?user_id=${userId}`
            );
            const favIds = favRes.data.data.map((f) => Number(f.product_id));
            dispatch(setFavourites(favIds));
          } catch (err) {
            console.error("Favoriler alınamadı:", err);
          }

          // COMMENTS
          try {
            const comRes = await axios.get(
              `https://www.elzabeauty.az/elza/comments.php?user_id=${userId}`
            );
            dispatch(setComments(comRes.data.data || []));
          } catch (err) {
            console.error("Yorumlar alınamadı:", err);
          }

          // CART ITEMS
          try {
            const cartRes = await axios.get(
              `https://www.elzabeauty.az/elza/cartItems.php?user_id=${userId}`
            );
            dispatch(setCartItems(cartRes.data.data || []));
          } catch (err) {
            console.error("Sepet alınamadı:", err);
          }

          // LOCATIONS
          try {
            const locRes = await axios.get(
              `https://www.elzabeauty.az/elza/locations.php?user_id=${userId}`
            );
            dispatch(setLocations(locRes.data.data || []));
          } catch (err) {
            console.error("Adres verisi alınamadı:", err);
          }

          navigate(`/${currentLanguage}`);
        } else {
          // E-poçt təsdiqlənməyib
          toast.warning(t("Zəhmət olmasa emailinizi təsdiqləyin."));
        }
      } else {
        // Heç bir uyğun istifadəçi tapılmadı
        toast.error(t("Email və ya şifrə yanlışdır"));
      }
    } catch (error) {
      console.error("Giriş hatası:", error);
      toast.error(t("Server xətası baş verdi"));
    }
  };

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <div className="bg-[#F4F4F4] py-[40px] md:py-[80px]">
        <div className="max-w-containerSm md:max-w-container mx-auto">
          <div data-aos="fade-up" className="md:flex justify-between">
            <div className="md:w-[612px] flex items-center">
              <div className="w-full">
                <img
                  alt="Logo"
                  className="w-[50px] md:w-[80px] mx-auto"
                  src={logo}
                ></img>
                <p className="text-[#222] text-[28px] md:text-[52px] font-bold text-center">
                  {t("Daxil Ol")}
                </p>
                <p className="text-[#5B5F62] text-[14px] md:text-[16px] mt-4 text-center">
                  {t("Elza Beauty-ə xoş gəlmisiniz!")}
                </p>
                <form className="mt-6 md:mt-8" onSubmit={loginSubmit}>
                  <p className="text-thirdColor text-[14px]">{t("E-poçt")}</p>
                  <input
                    type="email"
                    name="email"
                    className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                    placeholder={t("E-poçtunuzu daxil edin")}
                    value={email}
                    onChange={(e) => handleInputChange(e, "email")}
                    required
                  />

                  <p className="text-thirdColor text-[14px] mt-5">
                    {t("Şifrə")}
                  </p>
                  <input
                    type="password"
                    name="password"
                    className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                    value={password}
                    onChange={(e) => handleInputChange(e, "password")}
                    required
                  />

                  <button
                    type="submit"
                    className="w-full h-[44px] rounded-2xl bg-[#181D27] text-white mt-[48px] transition-colors"
                  >
                    {t("Daxil Ol")}
                  </button>
                  <a href={`/${currentLanguage}/register`}>
                    {" "}
                    <p className="text-[#222] text-[14px] mt-4 font-bold text-center">
                      {t("Yeni Hesab Yarat")}
                    </p>
                  </a>
                </form>
              </div>
            </div>
            <div className="md:w-[612px] text-firstColor mt-6 md:mt-0 hidden md:block">
              <img alt="Login" src={loginCover}></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
